import assign from 'object-assign';
import * as ActionTypes from './ActionTypes';
import ISe360User from './ISe360User';
import Se360UsersApi from './Se360UsersApi';
import IRole from './IRole';

function listSucceeded(result: ISe360User[]): any {
    return { type: ActionTypes.LIST_SE360_USERS_SUCCESS, result: result };
}

function listFailed(error: string): any {
    return { type: ActionTypes.LIST_SE360_USERS_FAILURE, error: error };
}

export function list(): any {
    return (dispatch: any, getState: any) =>
        Se360UsersApi.list()
            .then((result: any) => {
                dispatch(listSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(listFailed(error));
                throw error;
            });
}

function newSucceeded(result: IRole[]): any {
    return { type: ActionTypes.NEW_SE360_USER_SUCCESS, result: result };
}

function newFailed(error: string): any {
    return { type: ActionTypes.NEW_SE360_USER_FAILURE, error: error };
}

export function getNew(): any {
    return (dispatch: any, getState: any) =>
        Se360UsersApi.new()
            .then((result: any) => {
                dispatch(newSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(newFailed(error));
                throw error;
            });
}

function createSucceeded(userResult: ISe360User): any {
    return { type: ActionTypes.CREATE_SE360_USER_SUCCESS, result: userResult };
}

function createFailed(error: any): any {
    return { type: ActionTypes.CREATE_SE360_USER_FAILURE, error: error };
}

export function create(user: ISe360User): any {
    return (dispatch: any, getState: any) =>
        Se360UsersApi.create(user)
            .then((result: ISe360User) => {
                dispatch(createSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(createFailed(error));
                throw error;
            });
}

function editSucceeded(result: any): any {
    return { type: ActionTypes.EDIT_SE360_USER_SUCCESS, result: result };
}

function editFailed(error: string): any {
    return { type: ActionTypes.EDIT_SE360_USER_FAILURE, error: error };
}

export function edit(id: number): any {
    return (dispatch: any, getState: any) =>
        Se360UsersApi.edit(id)
            .then((result: any) => {
                dispatch(editSucceeded(result));
            })
            .catch((error: string) => {
                dispatch(editFailed(error));
                throw error;
            });
}

function updateSucceeded(result: ISe360User) {
    return { type: ActionTypes.UPDATE_SE360_USER_SUCCESS, result: result };
}

function updateFailed(error: any) {
    return { type: ActionTypes.UPDATE_SE360_USER_FAILURE, error: error };
}

export function update(input: ISe360User) {
    return (dispatch: any, getState: any) => {
        let data = assign({}, input);
        delete data.id;
        delete data.roleTranslationKey;

        return Se360UsersApi.update(input.id, data)
            .then((result: any) => {
                dispatch(updateSucceeded(result));
            })
            .catch((error: any) => {
                dispatch(updateFailed(error));
                throw error;
            });
    };
}

function deleteSucceeded(result: number) {
    return { type: ActionTypes.DELETE_SE360_USER_SUCCESS, result: result };
}

function deleteFailed(error: string) {
    return { type: ActionTypes.DELETE_SE360_USER_FAILURE, error: error };
}

function restoreSucceeded(result: number) {
    return { type: ActionTypes.RESTORE_SE360_USER_SUCCESS, result: result };
}

function restoreFailed(error: string) {
    return { type: ActionTypes.RESTORE_SE360_USER_FAILURE, error: error };
}

export function deleteSe360User(id: number) {
    return (dispatch: any, getState: any) =>
        Se360UsersApi.delete(id)
            .then((result: any) => {
                dispatch(deleteSucceeded(id));
            })
            .catch((error: string) => {
                dispatch(deleteFailed(error));
                throw error;
            });
}

export function restoreSe360User(id: number) {
    return (dispatch: any, getState: any) =>
        Se360UsersApi.restore(id)
            .then((result: any) => {
                dispatch(restoreSucceeded(id));
            })
            .catch((error: string) => {
                dispatch(restoreFailed(error));
                throw error;
            });
}
